<template>
  <footer class="footer">
    <v-container>
      <v-row>
        <v-col :sm="3" :lg="3" :cols="6">
          <h3>{{ $t('label.categories') }}</h3>
          <template v-for="category in categories">
            <router-link class="main-link" :to="`/product/category/${category.name}`" :key="category.name">
              {{ category.name }}
            </router-link>
            <p v-if="category.subCategories" :key="'sublinks' + category.name">
              <template v-for="(subCategory, i) in category.subCategories">
                <router-link :key="'link' + subCategory.name" :to="subCategory.link">
                  {{ subCategory.name }}
                </router-link>
                <span :key="'separator' + subCategory.name" v-if="i !== category.subCategories.length - 1">|</span>
              </template>
            </p>
          </template>
        </v-col>
        <v-col :sm="3" :lg="3" :cols="6">
          <h3>OLY</h3>
          <span class="main-link" @click="$router.push({ name: role === 'Agent' ? $constants.ROUTE_NAME.AGENT_TERMS_OF_SERVICE : $constants.ROUTE_NAME.TERMS_OF_SERVICE })">
            {{ $t('label.termsOfUse') }}
          </span>
          <!-- <router-link class="main-link" :to="role === 'Agent' ? $constants.ROUTE_NAME.AGENT_TERMS_OF_SERVICE : $constants.ROUTE_NAME.TERMS_OF_SERVICE">{{ $t('label.termsOfUse') }}</router-link> -->
          <router-link class="main-link" to="/privacy-policy">{{ $t('label.privacyPolicy') }}</router-link>
          <!-- <router-link class="main-link" to="/faq">FAQ</router-link> -->
          <h3 class="mt-6">{{ $t('label.findUs') }}</h3>
          <a class="main-link" :href="`mailto:${customerServiceEmail}`">{{ $t('label.emailUs') }}</a>
          <router-link v-if="isSGUser" class="main-link" to="/salon/list">{{ $t('label.ourStores') }}</router-link>
        </v-col>
        <v-col :sm="3" :lg="3" :cols="6">
          <div id="download-app">
            <h3>OLY App</h3>
            <a href="https://play.google.com/store/apps/details?id=com.oliving.app" target="_blank"><img class="app-store-badge mb-2" src="@/assets/google-play-badge.png" /></a>
            <a href="https://apps.apple.com/my/app/oly/id1572981807" target="_blank"><img class="app-store-badge mb-2" src="@/assets/app-store-badge.png" /></a>
            <a href="https://urldra.cloud.huawei.com/dbR4hINcpG" target="_blank"><img class="app-store-badge" src="@/assets/huawei.png" /></a>
          </div>
        </v-col>
        <!-- <v-col :cols="7" :md="5">
          <h3>Sign up for our newsletter</h3>
          <v-text-field class="subscribe-field" rounded dense outlined hide-details placeholder="Email" single-line>
            <template v-slot:append>
              <div class="primary darken-1 font-weight-bold">Join</div>
            </template>
          </v-text-field>
          <h3 class="mt-6">Connect with us</h3>
          <v-btn class="transparent" icon><v-icon class="transparent">mdi-facebook</v-icon></v-btn>
          <v-btn class="transparent" icon><v-icon class="transparent">mdi-instagram</v-icon></v-btn>
          <v-btn class="transparent" icon><v-icon class="transparent">mdi-youtube</v-icon></v-btn>
        </v-col> -->
      </v-row>
    </v-container>
  </footer>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  components: {},
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapGetters('auth', ['isSGUser']),
    ...mapGetters('page', ['categories', 'customerServiceEmail']),
    role() {
      return this.currentUser ? this.currentUser.roles : 'Member'
    }
  }
}
</script>

<style lang="scss" scoped>
*,
::v-deep a {
  color: white !important;
}

h3 {
  margin-bottom: 0.75rem;
}

.main-link {
  display: block;
  font-weight: bold;
  font-size: 0.8rem;
  cursor: pointer;
}

::v-deep a {
  text-decoration: none;
  font-size: 0.8rem;
}

.footer {
  background-color: var(--v-primary-lighten1);
  position: relative;
  z-index: 5;
}

::v-deep .subscribe-field {
  .v-input__control {
    overflow: hidden;
  }

  .v-input__slot {
    /* so Join button can stretch to the end */
    padding-right: 0;
  }

  .v-input__append-inner {
    align-self: stretch;
    align-items: center;
    justify-content: center;
    margin-top: 0 !important;

    flex-grow: 1;
    background-color: var(--v-primary-darken1);
  }
}

.app-store-badge {
  max-width: 150px;
}
</style>
